<template>
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div v-if="store.viewer_modal_type == 'team'">
        <div class="modal-content">
          <div class="modal-header">
            <h1
              class="modal-title fs-5 d-flex align-items-center justify-content-between"
              id="exampleModalLabel"
            >
              <span
                ><LogoLarge
                  :path="this_team.icon"
                  v-if="this_team.id"
                ></LogoLarge
              ></span>
              <span>{{ this_team.name }}</span>
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="store.setViewerExpandTeamId('')"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row fw-bold midtxt d-flex align-items-center">
              <div class="col-5" @click="sortBy('name')">
                Player
                <span v-if="sort_by == 'name'">
                  <i
                    v-if="sort_as == 'asc'"
                    class="bi bi-caret-up-fill text-primary"
                  ></i>
                  <i v-else class="bi bi-caret-down-fill text-primary"></i
                ></span>
              </div>
              <div class="col-5" @click="sortBy('pool')">
                Pool
                <span v-if="sort_by == 'pool'">
                  <i
                    v-if="sort_as == 'asc'"
                    class="bi bi-caret-down-fill text-primary"
                  ></i>
                  <i v-else class="bi bi-caret-up-fill text-primary"></i
                ></span>
              </div>
              <div class="col-2" @click="sortBy('sale')">
                Sale
                <span v-if="sort_by == 'sale'">
                  <i
                    v-if="sort_as == 'asc'"
                    class="bi bi-caret-up-fill text-primary"
                  ></i>
                  <i v-else class="bi bi-caret-down-fill text-primary"></i
                ></span>
              </div>
            </div>

            <div
              class="row midtxt text-muted d-flex align-items-center border rounded"
              v-for="p in sorted_players"
              :key="p"
            >
              <div class="col-6 text-start">
                <div class="row d-flex align-items-center">
                  <div class="col-4"><LogoSmall :path="p.pic"></LogoSmall></div>
                  <div class="col-8">{{ p.name }}</div>
                </div>
              </div>
              <div class="col-4 tinytxt text-start">
                {{ getPoolName(p.pool_id) }}
              </div>
              <div class="col-2">
                {{ formatToIndianCurrency(p.sale_price) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="store.viewer_modal_type == 'player'">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">
              Players List
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="store.setViewerModalType('')"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row d-flex align-items-center midtxt mb-1">
              <div class="col">
                <input
                  class="form-control"
                  placeholder="Search..."
                  v-model.trim="search"
                />
              </div>
              <div class="col d-flex align-items-center">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="soldSwitch"
                    :checked="statusRef === 'sold'"
                    @change="toggleStatus"
                  />
                  <label class="form-check-label" for="soldSwitch">
                    {{ statusRef }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row bg-info rounded" v-if="msg">
              <div class="col">{{ msg }}</div>
            </div>
            <div
              class="row d-flex align-items-center midtxt text-muted border rounded"
              v-for="(p, index) in sold_unsold_players"
              :key="p.id"
            >
              <div class="col-1">{{ index + 1 }}</div>
              <div class="col-2"><LogoSmall :path="p.pic"></LogoSmall></div>
              <div class="col-4 text-start tinytxt">{{ p.name }}</div>
              <div class="col-3 text-start tinytxt">{{ p.pool_name }}</div>
              <div class="col-2">
                <LogoSmall :path="p.team_icon"></LogoSmall>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { watchEffect, ref, computed, onMounted } from "vue";
import { useStore } from "@/store/index";
import LogoSmall from "../../bidder/logos/LogoSmall.vue";
import LogoLarge from "../../bidder/logos/LogoLarge.vue";
const store = useStore();
const this_team = ref({ id: "" });
const team_players = ref([]);
const sort_by = ref("name");
const sort_as = ref("asc");
const all_pools = ref([]);
const all_teams = ref([]);
const all_players = ref([]);
const statusRef = ref("sold");
const search = ref("");
const msg = ref("");
const compareStrings = (needle, haystack) => {
  var found = false;
  if (haystack.toLowerCase().includes(needle.toLowerCase())) {
    found = true;
  }
  return found;
};
const sold_unsold_players = computed(() => {
  var arr = [];
  all_players.value.forEach((p) => {
    if (statusRef.value == "sold") {
      if (p.team_id) {
        //add team logo & pool name
        p.team_icon = getTeamIcon(p.team_id);
        p.team_name = getTeamName(p.team_id);
        p.pool_name = getPoolName(p.pool_id);
        arr.push(p);
      }
    }
    if (statusRef.value == "unsold") {
      if (!p.team_id) {
        //add pool name
        p.pool_name = getPoolName(p.pool_id);
        p.team_name = ""; //this is added for generating search string.
        arr.push(p);
      }
    }
  });
  var sorted_arr = [];

  if (search.value.length > 1) {
    arr.forEach((p) => {
      var haystack_str = p.name + " " + p.team_name + " " + p.pool_name;
      if (compareStrings(search.value, haystack_str)) {
        sorted_arr.push(p);
      }
    });
  } else {
    sorted_arr = arr;
  }
  sorted_arr.sort((a, b) => a.name.localeCompare(b.name));
  return sorted_arr;
});
const getTeamIcon = (team_id) => {
  var icon = "";
  all_teams.value.forEach((t) => {
    if (t.id == team_id) {
      icon = t.icon;
    }
  });
  return icon;
};
const getTeamName = (team_id) => {
  var name = "";
  all_teams.value.forEach((t) => {
    if (t.id == team_id) {
      name = t.name;
    }
  });
  return name;
};

const toggleStatus = () => {
  statusRef.value = statusRef.value === "sold" ? "unsold" : "sold";
};
onMounted(() => {
  setTimeout(() => {
    fetchPools();
    //fetchTeams();
  }, 1000);
});
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")

    // Filters
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
};
const getPoolName = (pool_id) => {
  var pool_name = "";
  all_pools.value.forEach((p) => {
    if (p.id == pool_id) {
      pool_name = p.name;
    }
  });
  return pool_name;
};
const sortBy = (str) => {
  if (sort_by.value != str) {
    sort_by.value = str;
    sort_as.value = "asc";
  } else {
    flipSortAs();
  }
};
const flipSortAs = () => {
  if (sort_as.value == "asc") {
    sort_as.value = "desc";
  } else {
    sort_as.value = "asc";
  }
};

const fetchTeam = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("id", store.viewer_expand_team_id);
  if (teams) this_team.value = teams[0];
};
const fetchPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("team_id", store.viewer_expand_team_id);
  team_players.value = players;
};

const fetchAllPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
};
const sorted_players = computed(() => {
  var arr = [];
  team_players.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  if (sort_by.value == "name") {
    if (sort_as.value == "asc") {
      sorted_arr = arr.sort((a, b) => a.name.localeCompare(b.name));
    }
    if (sort_as.value == "desc") {
      sorted_arr = arr.sort((a, b) => b.name.localeCompare(a.name));
    }
  }
  if (sort_by.value == "pool") {
    if (sort_as.value == "asc") {
      sorted_arr = arr.sort((a, b) => a.pool_id - b.pool_id);
    }
    if (sort_as.value == "desc") {
      sorted_arr = arr.sort((a, b) => b.pool_id - a.pool_id);
    }
  }
  if (sort_by.value == "sale") {
    if (sort_as.value == "asc") {
      sorted_arr = arr.sort((a, b) => a.sale_price - b.sale_price);
    }
    if (sort_as.value == "desc") {
      sorted_arr = arr.sort((a, b) => b.sale_price - a.sale_price);
    }
  }
  return sorted_arr;
});
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
watchEffect(() => {
  if (store.viewer_expand_team_id) {
    fetchTeam();
    fetchPlayers();
  } else {
    this_team.value = {};
    team_players.value = [];
  }
  if (store.viewer_modal_type == "player") {
    fetchTeams();
    fetchPools();
    msg.value = "Fetching data...";
    setTimeout(() => {
      fetchAllPlayers(); //delayed this so that teams and pools arrays get populated
      msg.value = "";
    }, 1500);
  }
  if (!store.viewer_modal_type) {
    //console.log("clearing out player array...");
    all_players.value = [];
    statusRef.value = "sold";
  }
});
</script>
<style scoped>
.midtxt {
  font-size: 12px;
}
.tinytxt {
  font-size: 10px;
}
.microtxt {
  font-size: 8px;
}
</style>
